<template>
    <!-- 派对订单附件查看组件 -->
    <div>
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="附件查看"
        :visible="visible"
        @cancel="close"
        :width="650"
        :confirmLoading="downloadLoading"
        >
            <a-spin :spinning="spinning"> 
                <div class="pt16 pb8 pl16 pr16">
                    <images-uploader ref="imagesUpload" :readOnly="true"></images-uploader>
                </div>
            </a-spin>
            <template slot="footer">
                <div class="text-center">
                    <a-button type="primary" :loading="downloadLoading" @click="downloadFiles">打包下载</a-button>
                </div>
            </template>
        </a-modal>
    </div>
</template>

<script>
    import ImagesUploader from '@/components/common/images-uploader.component';
    export default {
        name: "partyOrderGetFiles",
        zh: "派对订单附件查看",
        components: {
            ImagesUploader
        },
        props: {
        },
        data() {
            return {
                visible: false,
                spinning: false,
                downloadLoading: false,
                recordId: null,
                isProceeds: true
            }
        },
        computed: {},
        watch: {
            visible(val) {

            }
        },
        methods: {
            open(isProceeds, recordId) {
                this.visible = true;
                this.recordId = recordId;
                this.isProceeds = isProceeds;
                this.getFiles();
            },
            getFiles() {
                let apiName = ['partyOrderRefundGetFiles', 'partyOrderProceedsGetFiles'];
                this.spinning = true;
                this.$api.order[apiName[Number(this.isProceeds)]]({
                    query: {
                        id: this.recordId
                    }
                }).then(res => {
                    this.spinning = false;
                    if (res && res.length > 0) {
                        let goodsImgList = res.map(i => i.ossUrl);
                        this.$refs.imagesUpload.pushImage(goodsImgList);
                    }
                })
            },
            downloadFiles() {
                if (this.downloadLoading) {
                    return false;
                }
                this.downloadLoading = true;
                let apiName = ['partyOrderRefundFilesDownload', 'partyOrderProceedsFilesDownload'];
                this.$api.order[apiName[Number(this.isProceeds)]]({
                    query: {
                        id: this.recordId
                    }
                }, {
                    responseType: "blob"
                }).then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/zip"
                    });
                    this.downloadUrl = window.URL.createObjectURL(blob);
                    a.setAttribute("href", this.downloadUrl);
                    a.setAttribute("download", `附件_${this.$moment().valueOf()}.zip`);
                    a.click();
                    this.downloadLoading = false;
                }).catch(err => {
                    this.downloadLoading = false;
                })
            },
            close() {
                this.visible = false;
            },
        },
        beforeCreate() {
        },
        created() {},
        updated() {},
        mounted() {},
    };
</script>

<style lang="scss">
</style>
